@if (filters?.length) {
  <div class="flex flex-wrap items-center gap-4">
    @for (filter of filters; track filter) {
      @if (appliedFilters && appliedFilters[filter.name]) {
        <ag1-pill [filter]="filter" [appliedFilters]="appliedFilters" />
      }
    }
  </div>
}
